import { Alert, Stack } from '@mui/material';
import { tr } from '../lib/i18n';
import { Button } from './button';
import { Component, type ReactNode } from 'react';

/** Keeps a crash in one page from blanking the whole app. */
export class ErrorBoundary extends Component<{ children: ReactNode; resetKey?: string }, { error: Error | null }> {
  override state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) {
    return { error };
  }
  override componentDidUpdate(prev: { resetKey?: string }) {
    if (prev.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null });
  }
  override render() {
    if (!this.state.error) return this.props.children;
    return (
      <Stack spacing={2} sx={{ p: 3 }}>
        <Alert severity="error">{tr('حدث خطأ غير متوقع في هذه الصفحة:', 'An unexpected error occurred on this page:')} {this.state.error.message}</Alert>
        <Button variant="outlined" onClick={() => this.setState({ error: null })} sx={{ alignSelf: 'flex-start' }}>{tr('إعادة المحاولة', 'Retry')}</Button>
      </Stack>
    );
  }
}
